import { useEffect, useState } from "react";
import MultiTable from "../../../../Common/MUITable";
import { ExportInspectionReport } from "../ExportInspectionReport";
import InspectionReportFilter from "../InspectionReportFilter";
import { getInspectionReportWards } from "../inspectionReportApi";
import { useConditionsOfStreetCornerBinsStore } from "./store/useConditionsOfStreetCornerBinsStore";

const columns = [
  {
    label: "Ward",
    field: "wardId",
    width: "120px",
    render: (row) => row.circleName ?? row.wardName ?? "N/A",
  },
  { label: "Location ID", field: "locationId", width: "120px" },
  { label: "Asset Code", field: "assetCode", width: "150px" },
  { label: "Asset Type", field: "assetType", width: "200px" },
  { label: "Date of inspection", field: "dateOfInspection", width: "140px" },
  { label: "Physical Condition", field: "physicalCondition", width: "140px" },
  { label: "Signboard", field: "signboard", width: "200px" },
  { label: "Paint", field: "paint", width: "200px" },
  { label: "Flooring", field: "flooring", width: "200px" },
  { label: "Littering Around bins", field: "litteringAroundBins", width: "160px" },
  { label: "Any Other", field: "anyOther", width: "110px" },
  { label: "Washing date(s)", field: "washingDates", width: "130px" },
];

const ConditionsOfStreetCornerBinsReport = () => {
  const [wardOptions, setWardOptions] = useState([]);
  const {
    rows,
    filters,
    isLoading,
    page,
    pageSize,
    totalRecords,
    fetchReport,
    resetFilters,
    changePage,
    changePageSize,
    fetchExportData,
  } = useConditionsOfStreetCornerBinsStore();

  useEffect(() => {
    const loadMasterData = async () => {
      try {
        const wards = await getInspectionReportWards();
        const activeWards = wards.filter((ward) => ward.isActive !== false);
        setWardOptions(activeWards);
      } catch (error) {
        console.error("Failed to load inspection report wards:", error);
        setWardOptions([]);
      }
    };

    loadMasterData();
    fetchReport(filters);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="content text-start">
      <div className="page-content">
        <div className="d-flex justify-content-between align-items-start flex-wrap gap-3 mt-3">
          <div>
            <h5 className="mb-1 fw-semibold">Conditions Of Street Corner Bins</h5>
            <p className="text-muted mb-0">
             Manage and monitor inspection records of Street corner Bins across all wards and zones.
            </p>
          </div>
          <div className="d-flex align-items-center flex-wrap">
            <ExportInspectionReport
              reportData={rows}
              loadExportData={fetchExportData}
              reportTitle="Conditions Of Street Corner Bins"
              columns={columns}
              fileName="ConditionsOfStreetCornerBins"
            />
          </div>
        </div>

        <div className="card shadow mt-3">
          <div className="card-body">
            <InspectionReportFilter
              initialValues={filters}
              wardOptions={wardOptions}
              onSearch={fetchReport}
              onReset={resetFilters}
            />

            <MultiTable
              loading={isLoading}
              needSRNumber
              rows={rows}
              columns={columns}
              serverPagination
              totalCount={totalRecords}
              page={page}
              rowsPerPage={pageSize}
              onPageChange={(_event, newPage) => changePage(newPage)}
              onRowsPerPageChange={(event) =>
                changePageSize(parseInt(event.target.value, 10))
              }
              rowsPerPageOptions={[10, 50, 100, 1000, 10000, 50000]}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default ConditionsOfStreetCornerBinsReport;
